import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, login, logout } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && user.role === "admin") navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        await logout();
        toast.error("This portal is for administrators only.");
        return;
      }
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-mahogany-950 px-6 grain" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><Logo size="md" /></div>
        <div className="bg-mahogany-900 gold-frame rounded-sm p-8">
          <div className="flex flex-col items-center mb-8">
            <div className="w-12 h-12 rounded-full border border-gold/40 flex items-center justify-center mb-4"><Lock size={20} className="text-gold" strokeWidth={1.5} /></div>
            <p className="overline">Private Administration</p>
            <h1 className="font-serif text-3xl text-cream mt-2">The Room, Behind the Scenes</h1>
          </div>
          <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
            <input required type="email" placeholder="Admin Email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-line" data-testid="admin-login-email" />
            <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-line" data-testid="admin-login-password" />
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit">{busy ? "Verifying…" : "Enter Admin"}</button>
          </form>
        </div>
        <p className="text-center text-cream/30 text-xs mt-6 uppercase tracking-[0.2em]">Authorized personnel only</p>
      </div>
    </div>
  );
}
